import { useContext, useCallback } from "react";
import { PageContext } from '../context';
import Text from "../data/text.json"

function useLocalization() {
  const { 
    lang, setLang } = useContext(PageContext);

  const t = useCallback((value) => Text[value][lang],[lang])

  return {
    lang, setLang,
    t
  }

  
}

export default useLocalization;